"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.standingOrderCalculation = exports.roundedPrice = exports.getStandingOrderProducts = exports.fillAndFilterProductList = exports.SUPPORTED_PAYMENT_METHODS = exports.MINIMUM_TEA_PACKS_PER_ORDER = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const MINIMUM_TEA_PACKS_PER_ORDER = exports.MINIMUM_TEA_PACKS_PER_ORDER = 6;
const SUPPORTED_PAYMENT_METHODS = exports.SUPPORTED_PAYMENT_METHODS = [_constants.PAYMENT_METHODS.unzer_cards, _constants.PAYMENT_METHODS.unzer_direct_debit_secured, _constants.PAYMENT_METHODS.unzer_invoice];
const getStandingOrderProducts = exports.getStandingOrderProducts = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(function* (items, getProducts, paymentInstruments, categoryName) {
    const products = yield fillAndFilterProductList(items, getProducts, categoryName);
    const paymentMethods = paymentInstruments.filter(pI => SUPPORTED_PAYMENT_METHODS.includes(pI.paymentMethodId));
    return paymentMethods.length > 0 && products.length > 0 ? products : [];
  });
  return function getStandingOrderProducts(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
const fillAndFilterProductList = exports.fillAndFilterProductList = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)(function* (items, getProducts, categoryName) {
    if (!items || items.length === 0) return [];
    const productsData = yield getProducts(items.map(u => u.productId));
    const _items = items.reduce((acc, curr) => {
      if (!categoryName || curr.c_classCategory === categoryName && (!curr.c_classCategoryId || curr.c_classCategoryId === categoryName)) {
        const product = productsData[curr.productId];
        const productInfo = product || false;
        const productIsOnline = !!productInfo;
        if (!productIsOnline || !product.c_purchasable) {
          return acc;
        }
        const additionalInfo = _objectSpread(_objectSpread({}, productInfo), {}, {
          productIsOnline,
          price: curr.price || (productInfo === null || productInfo === void 0 ? void 0 : productInfo.price) * curr.quantity || 0,
          priceAfterItemDiscount: curr.priceAfterItemDiscount || (productInfo === null || productInfo === void 0 ? void 0 : productInfo.c_priceDiscounted),
          priceAfterOrderDiscount: curr.priceAfterOrderDiscount || (productInfo === null || productInfo === void 0 ? void 0 : productInfo.priceAfterOrderDiscount),
          c_discountedPrice: curr.c_discountedPrice || (productInfo === null || productInfo === void 0 ? void 0 : productInfo.c_discountedPrice),
          quantity: curr.quantity,
          orderItemId: curr.id
        });
        return [...acc, _objectSpread(_objectSpread({}, curr), additionalInfo)];
      }
      return acc;
    }, []);
    return _items;
  });
  return function fillAndFilterProductList(_x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();
const roundedPrice = num => {
  return Math.round(num * 100) / 100;
};
exports.roundedPrice = roundedPrice;
const roundDownNumber = value => Math.floor(value * 100) / 100;
const standingOrderCalculation = (products, shippingCosts) => (products || []).reduce((pricing, product) => {
  const quantity = (product === null || product === void 0 ? void 0 : product.quantity) ?? 0;
  const productTotal = roundedPrice(((product === null || product === void 0 ? void 0 : product.pricePerUnit) ?? 0) * quantity);
  const discountedPrice = roundedPrice(((product === null || product === void 0 ? void 0 : product.c_priceDiscounted) ?? 0) * quantity);
  const productActual = ((product === null || product === void 0 ? void 0 : product.c_priceDiscounted) || (product === null || product === void 0 ? void 0 : product.pricePerUnit) || 0) * quantity;
  const productNet = ((product === null || product === void 0 ? void 0 : product.c_netPrice) ?? 0) * quantity;
  const tax = productActual - productNet;
  const discount = roundedPrice(discountedPrice > 0 ? productTotal - discountedPrice : 0);
  return {
    netValue: roundedPrice(pricing.netValue + productActual),
    discount: roundedPrice(pricing.discount + discount),
    tax: roundDownNumber(pricing.tax + tax),
    total: roundedPrice(pricing.total + productActual),
    shipping: (shippingCosts === null || shippingCosts === void 0 ? void 0 : shippingCosts.baseGrossPrice) ?? 0,
    currency: (product === null || product === void 0 ? void 0 : product.currency) ?? pricing.currency
  };
}, {
  netValue: 0,
  discount: 0,
  tax: (shippingCosts === null || shippingCosts === void 0 ? void 0 : shippingCosts.tax) ?? 0,
  shipping: (shippingCosts === null || shippingCosts === void 0 ? void 0 : shippingCosts.baseGrossPrice) ?? 0,
  total: (shippingCosts === null || shippingCosts === void 0 ? void 0 : shippingCosts.baseGrossPrice) ?? 0,
  currency: 'EUR'
});
exports.standingOrderCalculation = standingOrderCalculation;